import { Stack } from "@mui/material";
import {
  ActionToolbar,
  ToolbarActions,
  Table,
  SelectableToolbarActions,
} from "components/Table";
import { TableProps } from "types";

interface Props<T> extends TableProps<T> {
  actions?: ToolbarActions;
  selectedActions?: SelectableToolbarActions;
  onRefetch?: () => void;
  renderRowDetails?: (row: T) => React.ReactNode;
  sx?: any;
}

export const ActionTable = <T,>({
  actions,
  selectedActions,
  onRefetch,
  renderRowDetails,
  sx,
  ...props
}: Props<T>) => {
  return (
    <Stack flex={1} overflow="hidden" p={2}>
      <ActionToolbar
        {...{ selected: props.selected, actions, selectedActions, onRefetch }}
      />
      <Table
        selectable
        {...props}
        renderRowDetails={renderRowDetails}
        sx={sx} 
      />
    </Stack>
  );
};